//  -----   FUNZIONAMENTO   -----
/** 
- components > SidebarMenu.vue: 
viene definito un button con un onmousedown listener che chiama la funzione resize, memorizzando la coordinata X del click del mouse

- components > Sidebar.vue e components > Dash.vue > .content-wrapper:
ad ogni evento di mouseup rilevato nella sidebar o nel wrapper dei contenuti, viene richiamata stop_res(): 
se start_w è diverso da 0, allora viene interpretato come un tentativo di resize della sidebar.

- ci sono 5 componenti critici per l'adattamento dei contenuti conseguente al resize:
Dash.vue > .main-header > .logo ,   Sidebar.vue > aside
con classe .wtree, vengono ridimensionati al nuovo valore

Dash.vue > .navbar-static-top ,   Dash.vue > .content-wrapper,   Dash.vue > .main-footer
con classe .mtree, il cui margine sinistro deve necessariamente coincidere con la larghezza (aggiornata) della sidebar

!!!!!!!!
se onmouseup si verifica nei componenti footer, navbar e logo, il tentativo di resize non viene interpretato, e ci si assicura di resettare start_w 
*/

import {
  eventBus
} from '../eventbus'

export default {
  mounted: function () {
    this.$nextTick(function () {
      this.right = this.$Behaviors.side == 'dx';
      this.grab_wtree = this.right ? '.wtree_right' : '.wtree_left';
      this.grab_wfake = this.right ? '.wtree_fake_right' : '.wtree_fake_left';
      //this.attachListeners();
    })
  },
  created: function () {
    eventBus.$on("RESOURCE_LOAD_COMPLETE_EVENT", this.attachListeners)
  },
  data: function () {
    return {
      device: "desktop",
      start_w: 0,
      right: false,
      grab_wtree: '',
      grab_wfake: '',
      grab_toolbar: '#side-toolbar'
    }
  },
  methods: {
    attachListeners: function () {
      var vm = this;
      var starting_els = $('.resize-start');
      var stopping_els = $('.resize-stop');

      starting_els.on("mousedown", function (e) { //DESKTOP
        //LEFT: Coordinata X di partenza = larghezza sidebar
        //RIGHT: Coordinata X di partenza = largezza finestra - larghezza sidebar
        var width = $(vm.grab_wtree).width();
        if (vm.right) {
          width = window.innerWidth - width;
        }

        vm.start_resize(width);
      });

      starting_els.on("touchstart", function (e) { //PORTABLE
        vm.start_resize(e.originalEvent.changedTouches[0].screenX);
      });

    },
    reset_resize: function () {
      this.start_w = 0;
      var stopping_els = $('.resize-stop');
      //rimuovo i listeners mousemove e mouseup a sidebar e container
      stopping_els.off()

      if (!this.$root.help) {
        //BUG FIX HELP MODE
        $(this.grab_toolbar).css("z-index", 810);
      }
      //resetto larghezza placeholder e lo setto in background, + resetto profonsità toolbar
      $(this.grab_wfake).css("z-index", -1);
      $(this.grab_wfake).width($(this.grab_wtree).width())
    },
    start_resize: function (x) {
      var vm = this;
      this.start_w = x;
      var stopping_els = $('.resize-stop');
      var resetting_els = $('.resize-reset');
      stopping_els.on("mousemove", function (e) { //DESKTOP
        //setto placeholder in primo piano, così da vedere l'effetto di trasparenza 
        //il placeholder non deve sovrapporsi con la toolbar
        $(vm.grab_wfake).css("z-index", 813);
        $(vm.grab_toolbar).css("z-index", 9999);
        var w = $(vm.grab_wfake).width();
        if (vm.right) {
          w = window.innerWidth - w
        }
        //apply con fake = true, e larghezza placehodler come X di partenza (LEFT), largezza finestra - larghezza sidebar (RIGHT)
        //offset button 20
        var app = vm.right ? e.screenX + 20 : e.screenX - 20;
        vm.apply(app, true, w);
      });

      stopping_els.on("touchmove", function (e) { //PORTABLE
        //setto placeholder in primo piano, così da vedere l'effetto di trasparenza 
        $(vm.grab_wfake).css("z-index", 813);
        $(vm.grab_toolbar).css("z-index", 9999);
        var w = $(vm.grab_wfake).width();
        if (vm.right) {
          w = window.innerWidth - w
        }
        //apply con fake = true, e larghezza placehodler come X di partenza (LEFT), largezza finestra - larghezza sidebar (RIGHT)
        vm.apply(e.originalEvent.changedTouches[0].screenX, true, w);
      });

      stopping_els.on("mouseup", function (e) { //DESKTOP
        //offset button 20
        var app = vm.right ? e.screenX + 20 : e.screenX - 20;
        vm.stop_resize(app);
      });

      stopping_els.on("touchend", function (e) { //PORTABLE
        vm.stop_resize(e.originalEvent.changedTouches[0].screenX);
      });

      resetting_els.on("mouseup", function () { //DESKTOP
        vm.reset_resize();
      });

      resetting_els.on("touchend", function () { //PORTABLE
        vm.reset_resize();
      });

    },
    stop_resize: function (x) {
      var stopping_els = $('.resize-stop');
      //rimuovo i listeners mousemove e mouseup a sidebar e container
      stopping_els.off();
      //setto placeholder in background
      $(this.grab_wfake).css("z-index", -1);
      $(this.grab_toolbar).css("z-index", 810);

      if (this.start_w != 0) {
        this.apply(x, false);
      } else {
        this.start_w = 0;
      }
    },
    apply: function (end_w, fake, fake_start) {
      var grab_w,
        grab_m,
        tableModal = '.tableModal',
        start;

      //grab_w contiene il selector a wtree o wtree_fake a seconda di cosa si sta calcolando
      if (!fake) {
        start = this.start_w;
        grab_w = this.grab_wtree;
        grab_m = this.right ? '.mtree_right' : '.mtree_left';
      } else {
        start = fake_start;
        grab_w = this.grab_wfake
      }

      var difference = this.right ? start - end_w : end_w - start;
      var width = $(grab_w).width();
      var new_size = (width + difference);
      var contentWrapperWidth = (window.innerWidth - new_size);
      //Minimo: 270px, Massimo: Metà Larghezza Finestra
      new_size = Math.min((Math.max(270, new_size)), window.innerWidth / 2) + 'px';
      $(grab_w).width(new_size);
      var modalMargin = ((contentWrapperWidth - 640) / 2);
      //non modifico i margini se sto calcolando solo la larghezza del placeholder 
      if (!fake) {
        if (this.right) {
          $(grab_m).css("margin-right", new_size);
        } else {
          $(grab_m).css("margin-left", new_size);
          $(tableModal).css("margin-left", modalMargin + 'px');
          $(tableModal).css("margin-right", modalMargin + 'px');
        }
      }
      if (!fake) {
        //non resetto il "reale" punto di partenza se sto calcolando solo la larghezza del placeholder 
        this.start_w = 0;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sidebar_resize_mixin.js